'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Message;
(function (Message) {
    var MyMessage = /** @class */ (function () {
        function MyMessage() {
            var self = this;
            $('.trigChangeMessage').on('click', function (e) {
                var id = $(e.target).attr('data-show');
                $('.bulletChangeMessage').removeClass('message__block--show');
                $('.bulletChangeMessage[data-id="' + id + '"]').addClass('message__block--show');
                $('.recruit-message__btn__head').addClass('recruit-message__btn__head--show');
                self.moveMessageTop();
            });
        }
        MyMessage.prototype.moveMessageTop = function () {
            var headerHeight = $('#header').outerHeight();
            var MessagePosition = $('.paramViewMessage').offset().top;
            $('html, body').animate({
                scrollTop: MessagePosition - headerHeight
            }, 'slow');
        };
        return MyMessage;
    }());
    Message.MyMessage = MyMessage;
})(Message || (Message = {}));
exports.default = Message;
